























































































































import Vue from "vue";
import { AxiosResponse } from "axios";
import { ValidationObserver } from "vee-validate";
// api
import * as cwvApi from "@/features/coreWebVitals/axios";
import { getPublishers } from "@/commons/axios/publisher";
// component
import DialogCard from "@/commons/components/DialogCard.vue";
import CwvDomainsFilterCard from "@/features/coreWebVitals/components/cwvDomainsFilterCard.vue";
import NewCwvDomainCard from "@/features/coreWebVitals/components/newCwvDomainCard.vue";
import EditCwvDomainCard from "@/features/coreWebVitals/components/editCwvDomainCard.vue";
// types
import { DataTableHeader } from "vuetify/types";
import { PublishersResponse } from "@/commons/types";
import {
  Publisher,
  DomainForTable,
  GetDomainsResponse,
  AddCwvDomainBody,
  GetDomainResponse,
  UpdateCwvDomainBody,
} from "@/features/coreWebVitals/types";
// util
import * as notifyUtil from "@/commons/utils/notifyUtil";

export default Vue.extend({
  components: {
    "filter-card": CwvDomainsFilterCard,
    "dialog-card": DialogCard,
    "new-cwv-domain-card": NewCwvDomainCard,
    "edit-cwv-domain-card": EditCwvDomainCard,
    "validation-observer": ValidationObserver,
  },
  created() {
    this.fetchPublishers();
    this.fetchDomains();
  },
  data() {
    return {
      isPublishersLoading: true as boolean,
      isDomainsLoading: true as boolean,
      publisherFilterValue: "" as string,
      publishersInput: [] as number[],
      publishers: [] as Publisher[],
      domains: [] as DomainForTable[],
      searchValue: "" as string,
      formSearchValue: "" as string,
      index: 1 as number,
      createDomainNameInput: "" as string,
      createPublisherInput: 0 as number,
      tmpPublisherInput: 0 as number,
      showCreateDialog: false as boolean,
      showEditDialog: false as boolean,
      editingDomainId: 0 as number,
      oldDomainName: "" as string,
      oldPublisher: 0 as number,
      updateDomainNameInput: "" as string,
      updatePublisherInput: 0 as number,
      showDeleteDialog: false as boolean,
      deleteTargetDomain: undefined as DomainForTable | undefined,
      deleteTargetDomainName: "" as string,
    };
  },
  computed: {
    domainTableHeaders(): DataTableHeader[] {
      return [
        {
          text: String(this.$t("coreWebVitals.cwvDomains.tableHeaders.domain")),
          value: "domainName",
          width: "30%",
        },
        {
          text: String(this.$t("coreWebVitals.cwvDomains.tableHeaders.publisher")),
          value: "publisherName",
          width: "30%",
        },
        {
          text: String(this.$t("coreWebVitals.cwvDomains.tableHeaders.createdAt")),
          value: "createdAt",
          width: "20%",
        },
        {
          text: "",
          value: "action",
          align: "end",
          width: "20%",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    customSort(items: DomainForTable[], index: string[], isDesc: boolean[]): DomainForTable[] {
      items.sort((a: any, b: any) => {
        if (index[0] === "createdAt") {
          const dateA = new Date(a.rawCreatedAt.replace(/-/g, "/"));
          const dateB = new Date(b.rawCreatedAt.replace(/-/g, "/"));
          if (!isDesc[0]) {
            return dateB < dateA ? 1 : -1;
          } else {
            return dateB > dateA ? 1 : -1;
          }
        } else {
          if (typeof a[index[0]] !== "undefined") {
            if (!isDesc[0]) {
              return a[index[0]].localeCompare(b[index[0]]);
            } else {
              return b[index[0]].localeCompare(a[index[0]]);
            }
          }
        }
      });
      return items;
    },
    filterByDomainName(
      value: string | undefined | null,
      search: string | null,
      item: DomainForTable
    ): boolean {
      if (item.domainName === null) item.domainName = "";
      return value != null && search != null && item.domainName.includes(search);
    },
    execSearch(): void {
      this.index = 1;
      this.searchValue = this.formSearchValue;
    },
    clearSearch(): void {
      this.index = 1;
      this.searchValue = "";
    },
    async fetchPublishers() {
      this.isPublishersLoading = true;
      await getPublishers()
        .then((response: AxiosResponse<PublishersResponse>) => {
          this.publishers = response.data.publishers;
          this.tmpPublisherInput = response.data.publishers[0].publisherId;
          this.createPublisherInput = this.tmpPublisherInput;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.publishers"));
        });
      this.isPublishersLoading = false;
    },
    async fetchDomains() {
      this.isDomainsLoading = true;
      await cwvApi
        .getVisibleCwvDomains(this.publishersInput)
        .then((response: AxiosResponse<GetDomainsResponse>) => {
          this.domains = response.data.cwvDomains.map(element => {
            return {
              domainId: element.domainId,
              domainName: element.domainName,
              publisherName: element.publisherName,
              createdAt: this.convertDisplayDatetime(element.createdAt),
              rawCreatedAt: element.createdAt,
            };
          });
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.domains"));
        });
      this.index = 1;
      this.isDomainsLoading = false;
    },
    convertDisplayDatetime(datetime: string): string {
      // TODO: Analytics Report 一覧表示と同様の処理を行っているため、後ほどこのメソッドを utils に寄せる必要あり
      // safari用にハイフンをスラッシュに変換
      const escapedDatetime = datetime.replace(/-/g, "/");
      const convertDatetime = new Date(escapedDatetime) as Date;
      // DBはUTCなのでJSTに調整
      convertDatetime.setHours(convertDatetime.getHours() + 9);

      let displayDatetime = "" as string;
      // 24時間以内か確認
      const now = new Date();
      if ((now.getTime() - convertDatetime.getTime()) / (24 * 60 * 60 * 1000) <= 1) {
        // 1時間以内であれば分刻み、そうでなければ時間刻み
        if ((now.getTime() - convertDatetime.getTime()) / (60 * 60 * 1000) <= 1) {
          const minutesDiff = (now.getTime() - convertDatetime.getTime()) / (60 * 1000);
          displayDatetime = Math.floor(minutesDiff) + " Minutes ago";
        } else {
          const hourDiff = (now.getTime() - convertDatetime.getTime()) / (60 * 60 * 1000);
          displayDatetime = Math.floor(hourDiff) + " Hours ago";
        }
      } else {
        // ex)Wed Sep 22 2021
        displayDatetime = convertDatetime.toDateString().substring(4);
      }
      return displayDatetime;
    },
    async clickCreateDialog() {
      this.showCreateDialog = true;
    },
    async clickSaveOnCreateDialog() {
      (this.$refs.newCwvDomain as InstanceType<typeof ValidationObserver>)
        .validate()
        .then(async (success: boolean) => {
          if (!success) {
            return;
          }
          // CWV ドメイン新規作成処理
          const AddCwvDomainBody: AddCwvDomainBody = {
            domainName: this.createDomainNameInput,
            publisherId: this.createPublisherInput,
          };
          await cwvApi
            .addCwvDomain(AddCwvDomainBody)
            .then(() => {
              notifyUtil.notifySuccessMessage(
                this.$t("coreWebVitals.cwvDomains.notify.success.save")
              );
              this.clearCreateInputs();
              // 更新内容を反映するためにデータをフェッチ
              this.fetchDomains();
              this.showCreateDialog = false;
            })
            .catch(error => {
              if (error.response.status === 401) {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.sessionExpired")
                );
                this.$router.push({ name: "Login" });
              } else if (error.response.status === 409) {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.cwvDomains.duplicateRecord")
                );
              } else if (error.response.status === 422) {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.cwvDomains.recordCountOverflow")
                );
              } else
                notifyUtil.notifyErrorMessage(
                  this.$t("coreWebVitals.cwvDomains.notify.error.failedSave")
                );
            });
        });
    },
    clickCancelOnCreateDialog() {
      this.showCreateDialog = false;
    },
    async clickEditDialog(item: DomainForTable) {
      this.editingDomainId = item.domainId;
      await cwvApi
        .getCwvDomainInfo(this.editingDomainId)
        .then((response: AxiosResponse<GetDomainResponse>) => {
          this.oldDomainName = response.data.domainName;
          this.updateDomainNameInput = this.oldDomainName;
          this.oldPublisher = response.data.publisherId;
          this.updatePublisherInput = this.oldPublisher;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.domains"));
        });
      this.showEditDialog = true;
    },
    clickSaveOnEditDialog() {
      (this.$refs.editCwvDomain as InstanceType<typeof ValidationObserver>)
        .validate()
        .then(async (success: boolean) => {
          if (!success) {
            return;
          }
          const UpdateCwvDomainBody: UpdateCwvDomainBody = {
            domainName: this.updateDomainNameInput,
            publisherId: this.updatePublisherInput,
          };
          await cwvApi
            .updateCwvDomain(UpdateCwvDomainBody, this.editingDomainId)
            .then(() => {
              notifyUtil.notifySuccessMessage(
                this.$t("coreWebVitals.cwvDomains.notify.success.save")
              );
              // 更新内容を反映するためにデータをフェッチ
              this.fetchDomains();
              this.showEditDialog = false;
            })
            .catch(error => {
              if (error.response.status === 401) {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.sessionExpired")
                );
                this.$router.push({ name: "Login" });
              } else if (error.response.status === 409) {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.cwvDomains.duplicateRecord")
                );
              } else if (error.response.status === 422) {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.cwvDomains.recordCountOverflow")
                );
              } else
                notifyUtil.notifyErrorMessage(
                  this.$t("coreWebVitals.cwvDomains.notify.error.failedSave")
                );
            });
        });
    },
    clickCancelOnEditDialog() {
      this.showEditDialog = false;
    },
    clearCreateInputs() {
      this.createDomainNameInput = "";
      this.createPublisherInput = this.tmpPublisherInput;
    },
    clickDeleteDialog(item: DomainForTable) {
      this.deleteTargetDomain = item;
      this.deleteTargetDomainName = item.domainName;
      this.showDeleteDialog = true;
    },
    async clickOkOnDeleteDialog() {
      this.isDomainsLoading = true;

      await cwvApi
        .deleteCwvDomain(this.deleteTargetDomain?.domainId)
        .then(() => {
          notifyUtil.notifySuccessMessage(this.$t("coreWebVitals.cwvDomains.notify.success.delete"));
          // 更新内容を反映するためにデータをフェッチ
          this.fetchDomains();
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("coreWebVitals.cwvDomains.notify.error.failedDelete"));
          }
        })
        .finally(() => {
          this.deleteTargetDomain = undefined;
          this.deleteTargetDomainName = "";
          this.showDeleteDialog = false;
          this.isDomainsLoading = false;
        });
    },
    clickCancelOnDeleteDialog() {
      this.showDeleteDialog = false;
    },
  },
  watch: {
    showCreateDialog() {
      // CWV ドメイン新規作成ダイアログが閉じたタイミングでバリデーションリセット
      if (this.showCreateDialog) {
        (this.$refs.newCwvDomain as InstanceType<typeof ValidationObserver>).reset();
      }
    },
    showEditDialog() {
      // CWV ドメイン編集ダイアログが閉じたタイミングでバリデーションリセット
      if (this.showEditDialog)
        (this.$refs.editCwvDomain as InstanceType<typeof ValidationObserver>).reset();
    },
  },
});
